import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91c807b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "line-info-container",
  "aria-labelledby": "line-info-title"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "modal-content",
  id: "favorite-modal-title"
}, [
  /*#__PURE__*/_createTextVNode(" 즐겨찾기를 추가하시려면"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("로그인이 필요합니다. ")
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "modal-content",
  id: "delete-favorite-modal-title"
}, " 즐겨찾기를 삭제하시면 설정하신 모든 정보가 삭제됩니다. 즐겨찾기를 삭제하시겠습니까? ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "modal-content",
  id: "book-modal-title"
}, " 예약하시려면 로그인이 필요합니다. ", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "busstop-guide-modal-title" }, [
  /*#__PURE__*/_createTextVNode(" 버스 출발시간은 도로교통 사정상 오차가 있을 수 있습니다. 표기되고 있는 운행시간은 \"평균\"운행시간을 기준으로 목표시간을 설정한 것 입니다. 기점 출발 이후에 자세한 버스위치는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "modal-content emphasis" }, "실시간 버스위치"),
  /*#__PURE__*/_createTextVNode("를 참고해 주세요. ")
], -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 승차/하차 알림은 각각 1개 정류장만 설정할 수 있습니다. 선택하신 정류장으로 알림을 변경하면 기존 설정은 삭제됩니다. 변경하시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          class: "navigation-bar",
          title: "노선 정보",
          id: "line-info-title"
        }),
        _createCommentVNode(" 정류장 변경(추가/폐지)시 탭으로 노선정보 확인 가능 "),
        ($setup.shouldShowSegment)
          ? (_openBlock(), _createBlock($setup["SegmentedControl"], {
              key: 0,
              ref: "segmentedControl",
              segments: $setup.segmentTitles,
              initialIndex: $setup.currentSegmentIndex,
              onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
            }, null, 8 /* PROPS */, ["segments", "initialIndex"]))
          : _createCommentVNode("v-if", true),
        (!!$setup.lineInfo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["content-area", { 'no-book': !$setup.isBookable }]),
              ref: "contentArea",
              role: "region",
              "aria-label": "노선 상세 정보"
            }, [
              _createVNode($setup["LineInfoDetailHeader"], {
                class: "header",
                lineInfo: $setup.lineInfo!,
                isLinePathExisted: !!$setup.selectedTurnPaths?.length,
                busStops: $setup.selectedTurnBusStops,
                isFavoriteLine: $setup.isFavoriteLine,
                shouldShowTurnPathBtn: true,
                shouldShowFavoriteBtn: !$setup.isBookable,
                selectedTurn: $setup.selectedTurn,
                onOnClickLineTurnPathBtn: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowLineTurnPathModal(true))),
                onOnClickDetailBtn: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowLineInfoDetailExtended(true))),
                onOnClickFavoriteBtn: $setup.onClickFavorite
              }, null, 8 /* PROPS */, ["lineInfo", "isLinePathExisted", "busStops", "isFavoriteLine", "shouldShowFavoriteBtn", "selectedTurn"]),
              _createVNode($setup["LineInfoDetailContent"], {
                lineInfo: $setup.lineInfo!,
                selectedTimeIndex: $setup.selectedTimeIndex,
                availableTimes: $setup.availableTimes,
                isBusRunning: $setup.isBusRunning,
                turnBusLastSeatCountList: $setup.turnBusLastSeatCountList,
                hasDifferentTimes: $setup.availableTimes.length > 1,
                dailyBookInterval: $setup.dailyBookInterval,
                monthlyBookInterval: 
            $setup.monthlyBookable ? $setup.monthlyBookInterval : undefined
          ,
                isInsideShuttle: $setup.isInsideShuttle,
                onOnClickSelectTime: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleSelectTimeModal(true))),
                onOnClickBusImageIcon: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowBusInfoModal(true)))
              }, null, 8 /* PROPS */, ["lineInfo", "selectedTimeIndex", "availableTimes", "isBusRunning", "turnBusLastSeatCountList", "hasDifferentTimes", "dailyBookInterval", "monthlyBookInterval", "isInsideShuttle"]),
              _createVNode($setup["LineInfoDetailSelectBusStop"], {
                ref: "selectBusStopRef",
                class: "select-bus-stop",
                lineId: $setup.lineInfo?.id ?? '',
                turnId: $setup.selectedTurn?.id ?? '',
                busStops: $setup.selectedTurnBusStops,
                selectedBus: $setup.selectedBus,
                arrivalTimesForDisplay: $setup.arrivalTimes,
                favoriteLine: $setup.currentFavoriteLine,
                isInsideShuttle: $setup.isInsideShuttle,
                isBackwardLine: $setup.isBackwardLine,
                isBookable: $setup.isBookable,
                allBusesMap: $setup.allBusesMap,
                arrivalTimeOptions: $setup.arrivalTimeOptions,
                selectedArrivalTimeOption: $setup.selectedArrivalTimeOption,
                shouldShowBusLocations: $setup.shouldShowBusLocations,
                shouldShowBusArrivalTimeSelect: $setup.shouldShowBusArrivalTimeSelect,
                detourEndDtm: $setup.lineInfo?.detourEndDtm,
                onOnChangeArrivalTimeOption: $setup.onChangedArrivalTimeOption,
                onOnSelectPastTimeOption: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleSelectTimeModal(true))),
                onOnChangedBusStopSelection: $setup.onChangedBusStopSelection,
                onOnClickBusStopLocation: $setup.handleOnClickBusStop,
                onOnClickBusStopTimeGuide: _cache[5] || (_cache[5] = ($event: any) => ($setup.showBusStopTimeGuide = true)),
                onUpdateBusLocation: $setup.handleRefreshBusLocation,
                onOnClickScheduleBtn: $setup.showTimeTable,
                onOnClickBubble: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleShowSelectBusOrderModal(true))),
                onOnClickFavoriteStatusButton: $setup.handleClickFavoriteStatusButton,
                onOnClickBusIcon: $setup.handleClickBusIcon
              }, null, 8 /* PROPS */, ["lineId", "turnId", "busStops", "selectedBus", "arrivalTimesForDisplay", "favoriteLine", "isInsideShuttle", "isBackwardLine", "isBookable", "allBusesMap", "arrivalTimeOptions", "selectedArrivalTimeOption", "shouldShowBusLocations", "shouldShowBusArrivalTimeSelect", "detourEndDtm"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        ($setup.isBookable && $setup.showFooter)
          ? (_openBlock(), _createBlock($setup["LineInfoDetailFooter"], {
              key: 2,
              ref: "footer",
              class: "footer",
              isFavorite: $setup.isFavoriteLine,
              isMonthlyBookAvailable: $setup.monthlyBookable,
              isDailyBookAvailable: !!$setup.dailyBookInterval,
              isLoggedIn: $setup.isLoggedIn,
              onOnClickFavorite: $setup.onClickFavorite,
              onOnClickDailyBook: $setup.onClickDailyBook,
              onOnClickMonthlyBook: $setup.onClickMonthlyBook
            }, null, 8 /* PROPS */, ["isFavorite", "isMonthlyBookAvailable", "isDailyBookAvailable", "isLoggedIn"]))
          : _createCommentVNode("v-if", true),
        ($setup.contentArea)
          ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
              key: 3,
              container: $setup.contentArea
            }, null, 8 /* PROPS */, ["container"]))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.showSelectTimeModal)
        ? (_openBlock(), _createBlock($setup["SelectModal"], {
            key: 0,
            contents: $setup.availableTimesForModal,
            initialIndex: $setup.selectedTimeIndex,
            onHideModal: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggleSelectTimeModal(false))),
            onOnItemSelected: $setup.onTimeSelected,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "select-time-modal-title"
          }, null, 8 /* PROPS */, ["contents", "initialIndex"]))
        : _createCommentVNode("v-if", true),
      ($setup.showLoginRequriedAlertForFavorite)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 1,
            title: "즐겨찾기 추가",
            okButtonTitle: "로그인하기",
            cancelButtonTitle: "취소",
            onOnClickOkButton: $setup.goToLoginPage,
            onOnClickCancelButton: _cache[8] || (_cache[8] = ($event: any) => ($setup.showLoginRequriedAlertForFavorite = false)),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "favorite-modal-title"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.showAlertToDeleteFavorite)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 2,
            title: "즐겨찾기 삭제",
            okButtonTitle: "삭제하기",
            cancelButtonTitle: "취소",
            onOnClickOkButton: _cache[9] || (_cache[9] = ($event: any) => ($setup.toggleSetFavorite(false))),
            onOnClickCancelButton: _cache[10] || (_cache[10] = ($event: any) => ($setup.showAlertToDeleteFavorite = false)),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "delete-favorite-modal-title"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.showLoginRequriedAlertForBook)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 3,
            title: "예약하기",
            okButtonTitle: "로그인하기",
            cancelButtonTitle: "취소",
            onOnClickOkButton: $setup.goToLoginPage,
            onOnClickCancelButton: _cache[11] || (_cache[11] = ($event: any) => ($setup.showLoginRequriedAlertForBook = false)),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "book-modal-title"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.showBusStopTimeGuide)
        ? (_openBlock(), _createBlock($setup["InfoModal"], {
            key: 4,
            title: "운행시간 안내",
            confirmButtonTitle: "닫기",
            onOnClickConfirmButton: _cache[12] || (_cache[12] = ($event: any) => ($setup.showBusStopTimeGuide = false)),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "busstop-guide-modal-title"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowBusStopLayoutModal)
        ? (_openBlock(), _createBlock($setup["BusStopLayoutModal"], {
            key: 5,
            turnUid: $setup.selectedTurn?.id ?? '',
            busStopUid: $setup.selectedBusStopForLocation?.id ?? '',
            busStopName: $setup.selectedBusStopForLocation?.name ?? '',
            onOnClickCloseBtn: _cache[13] || (_cache[13] = ($event: any) => ($setup.shouldShowBusStopLayoutModal = false))
          }, null, 8 /* PROPS */, ["turnUid", "busStopUid", "busStopName"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowMonthlySeatAndPayment && $setup.selectedTurn)
        ? (_openBlock(), _createBlock($setup["MonthlyBookSeatAndPayment"], {
            key: 6,
            ref: "monthlyBookSeatAndPayment",
            turnId: $setup.selectedTurn.id,
            getOnBusStopId: $setup.selectedGetOnBusStop?.id ?? '',
            getOffBusStopId: $setup.selectedGetOffBusStop?.id ?? '',
            lineFare: $setup.selectedTurn.lineFare,
            seatsSelectable: !!$setup.monthlyBookInterval?.seatsSelectable,
            currentBookInterval: $setup.BookIntervalCode.MONTH,
            onToggleShowBookDetail: $setup.toggleShowBookDetail
          }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "lineFare", "seatsSelectable", "currentBookInterval"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowBookDetail && !!$setup.selectedTurn,
        onBackHandler: () => $setup.toggleShowBookDetail(false)
      }, {
        default: _withCtx(() => [
          ($setup.selectedTurn)
            ? (_openBlock(), _createBlock($setup["BookDetail"], {
                key: 0,
                turnId: $setup.selectedTurn.id,
                getOnBusStopId: $setup.selectedGetOnBusStop?.id ?? '',
                getOffBusStopId: $setup.selectedGetOffBusStop?.id ?? '',
                lineFare: $setup.selectedTurn.lineFare,
                bookIntervals: $setup.selectedTurn.bookIntervals ?? [],
                onOnClickClose: _cache[14] || (_cache[14] = ($event: any) => ($setup.toggleShowBookDetail(false))),
                onOnClickConfirm: $setup.onClickConfirmBook
              }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "lineFare", "bookIntervals"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowMonthlyBookDetail && !!$setup.selectedTurn,
        onBackHandler: () => $setup.toggleShowMonthlyBookDetail(false)
      }, {
        default: _withCtx(() => [
          ($setup.selectedTurn)
            ? (_openBlock(), _createBlock($setup["MonthlyBookDetailWithDuplicatedSeat"], {
                key: 0,
                turnId: $setup.selectedTurn.id,
                getOnBusStopId: $setup.selectedGetOnBusStop?.id ?? '',
                getOffBusStopId: $setup.selectedGetOffBusStop?.id ?? '',
                bookIntervals: $setup.selectedTurn.bookIntervals ?? [],
                bookableDatesInfos: $setup.bookableDatesInfos,
                lineFare: $setup.selectedTurn.lineFare,
                isMonthlyBook: true,
                onOnClickClose: _cache[15] || (_cache[15] = ($event: any) => ($setup.toggleShowMonthlyBookDetail(false)))
              }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "bookIntervals", "bookableDatesInfos", "lineFare"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createCommentVNode(" <PageModal\n      :shouldShow=\"shouldShowMap\"\n      :onBackHandler=\"() => toggleShowMap(false)\"\n    >\n      <MapOfBusStop\n        :targetBusStop=\"selectedBusStopForLocation\"\n        @onClickClose=\"toggleShowMap(false)\"\n      />\n    </PageModal> "),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowLineTurnPathMap,
        onBackHandler: () => $setup.toggleShowLineTurnPathModal(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["LineTurnPathMap"], {
            busStops: $setup.selectedTurnBusStops,
            paths: $setup.selectedTurnPaths,
            busLocations: $setup.busLocations,
            lineInfo: $setup.lineInfo!,
            isLinePathExisted: !!$setup.selectedTurnPaths?.length,
            isFavoriteLine: $setup.isFavoriteLine,
            isBookable: $setup.isBookable,
            shouldShowBusLocations: $setup.shouldShowBusLocations,
            detourBeginDtm: $setup.lineInfo?.detourBeginDtm,
            detourEndDtm: $setup.lineInfo?.detourEndDtm,
            detourReason: $setup.lineInfo?.detourReason,
            isInsideShuttle: $setup.isInsideShuttle,
            showCurrentLocation: $setup.isInsideShuttle,
            showAllBusStopNames: false,
            selectedTurn: $setup.selectedTurn,
            onOnClickClose: _cache[16] || (_cache[16] = ($event: any) => ($setup.toggleShowLineTurnPathModal(false))),
            onOnClickRefreshBtn: $setup.handleRefreshBusLocation,
            onOnClickDetailBtn: _cache[17] || (_cache[17] = ($event: any) => ($setup.toggleShowLineInfoDetailExtended(true))),
            onOnClickFavoriteBtn: $setup.onClickFavorite
          }, null, 8 /* PROPS */, ["busStops", "paths", "busLocations", "lineInfo", "isLinePathExisted", "isFavoriteLine", "isBookable", "shouldShowBusLocations", "detourBeginDtm", "detourEndDtm", "detourReason", "isInsideShuttle", "showCurrentLocation", "selectedTurn"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowTimeTable && !!$setup.targetBusStopForTimeTable,
        onBackHandler: () => $setup.toggleShowTimeTable(false)
      }, {
        default: _withCtx(() => [
          ($setup.targetBusStopForTimeTable)
            ? (_openBlock(), _createBlock($setup["TimeTableModal"], {
                key: 0,
                busStop: $setup.targetBusStopForTimeTable,
                turnId: $setup.selectedTurn?.id ?? '',
                onOnClickCloseBtn: _cache[18] || (_cache[18] = ($event: any) => ($setup.toggleShowTimeTable(false)))
              }, null, 8 /* PROPS */, ["busStop", "turnId"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      ($setup.busesForInfoModal.length && $setup.shouldShowBusInfoModal)
        ? (_openBlock(), _createBlock($setup["BusInfoModal"], {
            key: 7,
            buses: $setup.busesForInfoModal,
            onOnClickClose: _cache[19] || (_cache[19] = ($event: any) => ($setup.toggleShowBusInfoModal(false)))
          }, null, 8 /* PROPS */, ["buses"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowPastArrivalTimeModal)
        ? (_openBlock(), _createBlock($setup["PastArrivalTimeModal"], {
            key: 8,
            lineTurnUid: $setup.paramsForPastArrivalTime.lineTurnUid ?? '',
            busOrder: $setup.paramsForPastArrivalTime.busOrder ?? 1,
            busStops: $setup.selectedTurn?.busStops ?? [],
            onOnClickCloseBtn: _cache[20] || (_cache[20] = ($event: any) => ($setup.toggleShowPastArrivalTimeModal(false)))
          }, null, 8 /* PROPS */, ["lineTurnUid", "busOrder", "busStops"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowSelectBusOrderModal)
        ? (_openBlock(), _createBlock($setup["BusOrderSelectModal"], {
            key: 9,
            busLocations: $setup.busLocations ?? [],
            selectedBus: $setup.selectedBus,
            isInsideShuttle: $setup.isInsideShuttle,
            isBusRunning: $setup.isBusRunning,
            turnBusLastSeatCountList: $setup.turnBusLastSeatCountList,
            onOnItemSelected: $setup.handleChangeSelectedBus,
            onHideModal: _cache[21] || (_cache[21] = ($event: any) => ($setup.toggleShowSelectBusOrderModal(false)))
          }, null, 8 /* PROPS */, ["busLocations", "selectedBus", "isInsideShuttle", "isBusRunning", "turnBusLastSeatCountList"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowLineInfoDetailExtended && !!$setup.lineInfo,
        onBackHandler: () => $setup.toggleShowLineInfoDetailExtended(false)
      }, {
        default: _withCtx(() => [
          ($setup.lineInfo)
            ? (_openBlock(), _createBlock($setup["LineInfoDetailExtended"], {
                key: 0,
                lineInfo: $setup.lineInfo,
                isInsideShuttle: $setup.isInsideShuttle,
                busStops: $setup.selectedTurnBusStops,
                departureTimes: $setup.availableTimes,
                nextBusStopChangeDateTime: $setup.nextBusStopChangeDateTime,
                onOnClickClose: _cache[22] || (_cache[22] = ($event: any) => ($setup.toggleShowLineInfoDetailExtended(false)))
              }, null, 8 /* PROPS */, ["lineInfo", "isInsideShuttle", "busStops", "departureTimes", "nextBusStopChangeDateTime"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createCommentVNode(" '즐겨찾기 승하차 정류장 변경'전 주의사항 알림 모달 "),
      ($setup.shouldShowChangeFavoriteBusStopAlert)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 10,
            title: "도착 사전 알림 변경 안내",
            okButtonTitle: "변경하기",
            cancelButtonTitle: "취소",
            onOnClickOkButton: $setup.handleClickChangeFavoriteBusStopAlertOk,
            onOnClickCancelButton: $setup.handleClickChangeFavoriteBusStopAlertCancel
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 승/하차 정류장 선택 모달 "),
      (
        $setup.shouldShowSelectFavoriteBusStopTypeAddModal ||
        $setup.shouldShowSelectFavoriteBusStopTypeChangeModal
      )
        ? (_openBlock(), _createBlock($setup["FavoriteBusStopTypeSelectModal"], {
            key: 11,
            shouldShow: 
        $setup.shouldShowSelectFavoriteBusStopTypeAddModal ||
        $setup.shouldShowSelectFavoriteBusStopTypeChangeModal
      ,
            isAddMode: $setup.shouldShowSelectFavoriteBusStopTypeAddModal,
            onOnSelectGetOn: _cache[23] || (_cache[23] = ($event: any) => ($setup.handleSelectFavoriteBusStopType(true))),
            onOnSelectGetOff: _cache[24] || (_cache[24] = ($event: any) => ($setup.handleSelectFavoriteBusStopType(false))),
            onOnClose: $setup.handleCloseSelectFavoriteBusStopTypeModal
          }, null, 8 /* PROPS */, ["shouldShow", "isAddMode"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}